/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import * as Sentry from '@sentry/browser';
import { CHANGE_DATE_REQUEST_STAGES as stages } from 'config/constants';
import { getChangeDatesRequestPageLink } from 'lib/links';

const stageToPath = {
  [stages.EDIT]: '/edit',
  [stages.REVIEW]: '/review',
  [stages.SUBMITTING]: '/submitting',
  [stages.CONFIRMED]: '/confirmed',
};

export const useSyncUrlWithState = ({ bookingId, stage }) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const suffix = stageToPath[stage];
    const path = getChangeDatesRequestPageLink(bookingId, suffix);

    if (path !== location.pathname) {
      Sentry.addBreadcrumb({
        category: 'change-dates-request',
        message: `stage=${stage}`,
        data: { bookingId, stage, from: location.pathname, to: path },
        level: Sentry.Severity.Info,
      });
      history.replace(path);
    }
  }, [bookingId, stage, history, location.pathname]);
};
